import { render, staticRenderFns } from "./NewInvoice.vue?vue&type=template&id=7c284e0b&scoped=true&"
import script from "./NewInvoice.vue?vue&type=script&lang=ts&"
export * from "./NewInvoice.vue?vue&type=script&lang=ts&"
import style0 from "./NewInvoice.vue?vue&type=style&index=0&id=7c284e0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c284e0b",
  null
  
)

export default component.exports